import styled, { RuleSet } from 'styled-components';
import { FlexColumn } from '../../../../../styled/common';

export const FormBlockContainer = styled(FlexColumn)`
  gap: 15px;
  padding: 20px 15px;
  background-color: ${({ theme }) => theme.colors.background.primary};
  border-radius: 21px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: 40px;
    border: 1px solid ${({ theme }) => theme.colors.border.secondary};
    gap: 30px;
  }
`;

export const FormChildrenContainer = styled(FlexColumn)<{
  styles?: RuleSet<object>;
}>`
  gap: 15px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    gap: 20px;
  }

  ${({ styles }) => styles};
`;
